import React, {useEffect, useRef} from 'react';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Col, Row, Select } from "antd";
import {CreateSelectField, CreateTextField} from "../../helpers/InputCreator";
import {Field, reduxForm} from "redux-form";
import languages from "../../language/languages";

const LogsTableHeader = (props) => {

  const { initialValues,whereColumn} = props;
  const localProps =useRef(props);
  useEffect(() => {
    localProps.current.initialize(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if(whereColumn === 'operation') {
      localProps.current.change('whereValue', 'Login');
    } else {
      localProps.current.change('whereValue', '');
    }
  }, [whereColumn]);



  const renderOperations=()=>
  {
      if(!props.logOperations || props.logOperations<=0)
          return '';
      return props.logOperations.map((logOperation)=><Select.Option key={logOperation.name}>{logOperation.name}</Select.Option>);
  };

  const renderWhereValue = () => {
    if(props.whereColumn === 'operation') {
      return (
        <Field name="whereValue"
               component={CreateSelectField}
               style={{width:200}}
               placeholder=""
               defaultValue={'Login'}
               hasFeedback>
            {renderOperations()}
        </Field>
      );
    } else {
      return (
        <Field name="whereValue"
               component={CreateTextField}
               placeholder={languages[props.language].searchLabel}
               hasFeedback />
      );
    }
  };

  return (
    <Row gutter={4}>
      <Col xs={12} md={4}>
        <Field name="whereColumn"
               component={CreateSelectField}
               placeholder=""
               style={{width: '100%'}}
               hasFeedback>
          <Select.Option value="date">Fecha</Select.Option>
          <Select.Option value="userName">Usuario</Select.Option>
          <Select.Option value="operation">Operacion</Select.Option>
          <Select.Option value="ip">IP</Select.Option>
        </Field>
      </Col>
      <Col xs={12} md={4}>
        <Field name="whereOp"
               component={CreateSelectField}
               placeholder=""
               style={{width: '100%'}}
               hasFeedback>
          <Select.Option value="like">Contiene</Select.Option>
          <Select.Option value="=">Igual a</Select.Option>
        </Field>
      </Col>
      <Col xs={24} md={6}>
        {renderWhereValue()}
      </Col>
      <Col xs={24} md={10}>
        <Form.Item>
          <Row gutter={8}>
            <Col xs={12} md={8}>
              <Button block icon={<LegacyIcon type={'filter'} />} type={'primary'} htmlType={'button'}
                      onClick={props.handleSubmit(props.handleFilter)}>{languages[props.language].filter}</Button>
            </Col>
            <Col xs={12} md={8}>
              {props.filter ?
                <Button block type={'ghost'} icon={<LegacyIcon type={'cross'} />} htmlType={'button'}
                        onClick={props.handleClean}>{languages[props.language].clearLabel}</Button> : ''}
            </Col>
            <Col xs={12} md={8}>
              <Button block icon={<LegacyIcon type={'download'} />} type={'primary'} htmlType={'button'}
                      onClick={props.handleExport}>{languages[props.language].export}</Button>
            </Col>
          </Row>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default reduxForm({form: 'logs_report_form'})(LogsTableHeader);